/*
 *in this module there are all the functions to create
 *  - plot the marker
 *  - manipulate the marker
 */

/**
 * import modules
 */
import VectorLayer from 'ol/layer/Vector'
import {Icon, Style} from 'ol/style'
import Draw from 'ol/interaction/Draw'
import VectorSource from 'ol/source/Vector'
import Modify from 'ol/interaction/Modify'
import Collection from 'ol/Collection'
import fralayers from '../frastaff/fralayers'
import functions from '../common/functions'

/**
 * set the dummy parameter iDelRef to 0
 * it's used to refresh the source of the fralayers and display the new marker
 */

let iDelRef = 0

const initVector = (mapView, overlay, getLayer) => {
  /**
   * set the marker ID to 0
   */

  let MarkId = 0

  /**
   * marker source
   */

  const Msource = new VectorSource()

  /**
   * marker variable for the symbols
   */

  const myColors = ['rgba(255,255,255,0.1)']
  const mySource = ['/img/symbols/marker100.png', '/img/symbols/marker101.png', '/img/symbols/marker102.png']

  /**
   * add the correct symbols and prevent duplicates
   */

  let iterator = 0

  const styleFn = (symbol) => {
    let retSytle

    /**
     * get the current style if is already setup
     */

    if (typeof (symbol.get('styledwithcolor')) !== 'undefined') {
      retSytle = new Style({
        image: new Icon({
          // opacity: 0.95,
          src: symbol.get('mysource'),
          color: symbol.get('styledwithcolor'),
          anchor: [14, 40],
          anchorXUnits: 'pixels',
          anchorYUnits: 'pixels'
        })
      })
    }
    /**
     * else set the new style
     */
    else {
      symbol.set('styledwithcolor', myColors[iterator])
      symbol.set('mysource', mySource[iterator])

      retSytle = new Style({
        image: new Icon({
          src: mySource[iterator],
          color: myColors[iterator]
        })
      })
      /**
       * removing the last symbols prevent to add duplicates
       */

      mySource.shift()
    }
    return [retSytle]
  }

  /**
   * marker layer
   * set the z-index of the layer to 6 to be sure that is on top of all the others one
   */

  const markLayer = new VectorLayer({
    source: Msource,
    style: styleFn
  })

  markLayer.setZIndex(6)

  /**
   * add the markLayer layer to the map
   */

  mapView.addLayer(markLayer)

  /**
   * marker tool handler
   */

  $('#FraMarker').click(function (e) {
    /**
     * prevent default behaviour
     * add the mark interaction to the map
     * hide the popup
     */
    e.preventDefault()

    addMark('Point')

    overlay.setPosition(undefined)
    /**
     * hide the empty comment error
     */

    $('.emptyComm').css('display', 'none')

    /**
     * check if it's a mobile device
     * hide the tool menu if it's open
     * hide the main bar if it's open
     */

    if (functions.mobileTabletView()) {
      if ($('#dropdownToolsMobile em').hasClass('fa-caret-down')) {
          $('#dropdownToolsMobile').trigger('click')
      }
      if ($('#mainNav').hasClass('show')) {
        $('#mainNav').removeClass('show')
      }
    }
  })

  /**
   * these var are for the creation of the marker
   * they are global so we can remove it later
   */

  let mark
  let counter = true

  /**
   * add the marker
   */

  const addMark = (Type) => {
    /**
     * set counter to true
     * we use it to prevent error when we remove a marker
     */

    counter = true

    /**
     * set the mark interaction
     */

    mark = new Draw({
      source: Msource,
      type: Type
    })

    /**
     * limit the number of markers to 4
     */

    if (Msource.getFeatures().length < 1) {
      /**
       * disable the buttons to prevent multiple instances
       */

      $('#FraMarker').prop('disabled', true)
      $('.markers button').prop('disabled', true)

      /**
       * add the mark interaction to the map
       */

      mapView.addInteraction(mark)

      /**
       * this occurs when you finish to draw the marker
       */

      mark.on('drawend', () => {
        counter = true

        drawingMarker()

        /**
         * Bring form modal
         */
        $('#fra-form-modal').modal({
            backdrop: 'static',
            keyboard: false
        })

        $('#fra-form-modal').modal('show')

        /**
         * hide the plot marker button
         * collapse all the other panels
         * display the form div
         */

        /**
         * show the menu and the form when the marker is plotted with a delay
         */

        setTimeout(function () {
          if (functions.mobileTabletView()) {
            $('#dropdownToolsMobile').trigger('click')
          }
        }, 200)
      })

      /**
       * this occurs after you finish to draw the marker
       */

      markLayer.on('change', () => {
        mapView.removeInteraction(mark)

        /**
         * enable the buttons
         */

        setTimeout(() => {
          $('#FraMarker').prop('disabled', false)
          $('.markers button').prop('disabled', false)
        }, 300)

        /**
         * we check if we are adding or removing markers
         */

        if (counter === true) {
          /**
           * we set immediately the counter to false and stop to run this function after it finish
           * apply the correct id to the last plotted marker
           */

          counter = false
          let ind = Msource.getFeatures().length - 1
          Msource.getFeatures()[ind].setId(MarkId - 1)
        }

        /**
         * end markLayer.on('change', () => {
         */
      })
      /**
       * end if (Msource.getFeatures().length < 1)
       */
    }

    /**
     * if the Msource.getFeatures().length is > 1
     */

    else {
      /**
       * remove the mark interaction
       * display the max plotted markers message
       */

      mapView.removeInteraction(mark)
    }

    /**
     * end function addMark (Type)
     */
  }

  /**
   * create the marker list
   */

  const drawingMarker = () => {
    /**
     * set counter to true
     */

    counter = true

    /**
     * at this point the source is empty, so the first ID it will be 0
     * we add 1 to start from 1
     */

    let markText = Msource.getFeatures().length + 1

    /**
     * we add a new option to the select element
     */

    $('<option>', {
      'value': MarkId,
      'text': `Marker ${markText}`
    }).attr('id', MarkId).appendTo('#tlfeature')

    /**
     * we add a new textarea for each option
     */

    $('<textarea>', {
      'name': `Marker ${markText}`,
      'rows': '4',
      'class': MarkId,
      'maxlength': '100',
      'value': '',
      'placeholder': $('#textareaprompt').val()
    }).appendTo('.textDiv')

    /**
     * we select to default the last marker in the select element
     * we hide all the textareas
     * we display the current textarea
     */

    $('#tlfeature').val(MarkId).hide()
    $('.textDiv textarea').hide()
    $(`.${MarkId}`).show()

    /**
     * we display the markers buttons
     * we display the complete marker div that included select/textarea/buttons
     * we style the textarea
     */

    $('.markers').css({
      'display': 'inline-block',
      'height': '28px',
      'width': '100%'
    })
    $('.markerdiv').show()

    $(`.${MarkId}`).css({
      'height': '88px',
      'display': 'block',
      'margin-bottom': '8px'
    })

    /**
     * we increase the marker ID plus 1
     */

    MarkId += 1

    /**
     * end drawingMarker = () =>
     */
  }

  /**
   * hide the markers buttons in the fault form div
   * hide the location button in the fault list div
   */

  // $('.markerdiv').hide()
  // $('#plmarkloc').hide()
  // $('#markdel').hide()

  /**
   * display the correct textarea when the select elemet change
   * both for the fault form div and fault list div
   */

  $(function () {
    $('#tlfeature').change(function () {
      /**
       * hide the popup
       */

      overlay.setPosition(undefined)

      /**
       * we hide all the textareas
       * we display the current textarea
       */

      $('.textDiv textarea').hide()
      $('.' + $(this).val()).show()

  s   })

    $('#plfeature').change(function () {
      /**
       * hide the popup
       */

      overlay.setPosition(undefined)

      /**
       * show the locate button if the select element is empty
       */
      if ($('#plfeature').val() !== 'View or edit ...') {
        $('#plmarkloc').show()
      }
      else {
        $('#plmarkloc').hide()
      }
    })
  })

  /**
   * markers button handler
   */

  /*
   * marker location button
   */

  $('#markloc').on('click', function (e) {
    /**
     * prevent default behaviour
     * hide the popup
     */

    e.preventDefault()

    overlay.setPosition(undefined)

    /**
     * prevent error enabling the click just if the value of the option selected is not empty
     */

    if ($('#tlfeature').val() !== null) {
      /**
       * check if it's a mobile device
       * hide the tool menu if it's open
       */
      if (functions.mobileTabletView()) {
        if ($('#dropdownToolsMobile em').hasClass('fa-caret-down')) {
          $('#dropdownToolsMobile').trigger('click')
        }
      }

      /**
       * get the select element
       * get the actual selected option
       * get the coordinates from the marker source checking the ID
       */

      let sel = document.getElementById('tlfeature')
      let selIds = sel[sel.selectedIndex].id
      let coord = Msource.getFeatureById(parseInt(selIds)).getGeometry().getCoordinates()

      /**
       * move the map to the exact location of the marker
       * we don't move the zoom, we use the same level the customer is
       */

      mapView.getView().centerOn([parseFloat(coord[0]), parseFloat(coord[1])], mapView.getSize(), [($('#map').innerWidth() / 2), ($('#map').innerHeight() / 2)])
    }
  })

  /**
   * marker drag button
   */

  $('#markdrag').on('click', function (e) {
    /**
     * prevent default behaviour
     * hide the popup
     */

    e.preventDefault()

    overlay.setPosition(undefined)

    /**
     * Hide form modal
     */
    $('#fra-form-modal').modal('hide')

    /**
     * prevent error enabling the click just if the value of the option selected is not empty
     */

    if ($('#tlfeature').val() !== null) {
      /**
       * check if it's a mobile device
       * hide the tools menu if it's open
       */

      if (functions.mobileTabletView()) {
        if ($('#dropdownToolsMobile em').hasClass('fa-caret-down')) {
          $('#dropdownToolsMobile').trigger('click')
       }
      }

      /**
       * disable the buttons to prevent to launch more instances of the function
       */

      $('#FraMarker').prop('disabled', true)
      $('.markers button').prop('disabled', true)

      /**
       * get the select element
       * get the actual selected option
       */

      let sel = document.getElementById('tlfeature')
      let ids = sel[sel.selectedIndex].id

      /**
       * create the drag interaction
       * add it to the map
       */

      let dragInteraction = new Modify({
        features: new Collection([Msource.getFeatureById(parseInt(ids))]),
        style: null
      })

      mapView.addInteraction(dragInteraction)

      /**
       * pointermove event listen
       */

      mapView.on('pointermove', function (evt) {
        /**
         * if you are moving the map return
         */

        if (evt.dragging) {
          return
        }

        /**
         * change the pointer style to match the marker layer
         */

        let pixel = mapView.getEventPixel(evt.originalEvent)
        let hit = mapView.forEachLayerAtPixel(pixel, () => {
          return true
        }, null, (layer) => {
          return layer === markLayer
        })
        mapView.getTargetElement().style.cursor = hit ? 'pointer' : ''
      })

      /**
       * modifyend event listener
       */

      dragInteraction.on('modifyend', () => {
        /**
         * remove the interaction when the customer finish to drag the marker
         */
        mapView.removeInteraction(dragInteraction)

        /**
         * enable the buttons
         */

        setTimeout(function () {
          $('#FraMarker').prop('disabled', false)
          $('.markers button').prop('disabled', false)
        }, 300)

        /**
         * check if it's a mobile device
         * show the tools menu
         */

        if (functions.mobileTabletView()) {
          setTimeout(function () {
            $('#dropdownToolsMobile').trigger('click')
          }, 200)
        }

        /**
         * pointermove event listen
         */

        mapView.on('pointermove', function (evt) {
          /**
           * if you are moving the map return
           */

          if (evt.dragging) {
            return
          }

          /**
           * change the pointer style to match the marker layer
           */

          let pixel = mapView.getEventPixel(evt.originalEvent)
          let hit = mapView.forEachLayerAtPixel(pixel, () => {
            return true
          }, null, (layer) => {
            return layer === getLayer
          })
          mapView.getTargetElement().style.cursor = hit ? 'pointer' : ''
        })

        /**
         * end dragInteraction.on('modifyend', () =>
         * end if ($('#tlfeature').val() !== null)
         * end $('#markdrag').on('click', function (e) {
         */

        /**
         * Bring form modal
         */
        $('#fra-form-modal').modal('show')
      })
    }
  })

  /**
   * marker delete button
   */
  $('#markdel').on('click', function (e) {
    /**
     * prevent default behaviour
     * hide the popup
     * set counter to false
     */

    e.preventDefault()

    overlay.setPosition(undefined)

    counter = false

    /**
     * prevent error enabling the click just if the value of the option selected is not empty
     */

    if ($('#tlfeature').val() !== null) {
      /**
       * get the select element
       */

      let sel = document.getElementById('tlfeature')

      /**
       * add the last symbols to the main symbols array
       */

      mySource.unshift(Msource.getFeatureById(sel.value).getProperties().mysource)

      /**
       * remove the marker connected to that ID
       */

      Msource.removeFeature(Msource.getFeatureById(sel.value))

      /**
       * remove the connected textarea
       * remove the connected selected option
       * set the selected option to the default one ''
       */

      $('.' + parseInt(sel.value)).remove()

      $('#' + sel[sel.selectedIndex].id).remove()
      $('#tlfeature').val('')

      /**
       * hide the form
       * hide the fault form div
       * close the tools menu
       * display the marker button
       */

      if (functions.mobileTabletView()) {
        $('#dropdownToolsMobile').trigger('click')
      }

      $('#FraMarker').show()

      /**
       * reset the val of fileToUpload
       * reset the source of the thumbnail preview
       * hide the thumbnail preview
       */

      $('#fileToUpload').val('')
      let photoOutput = document.getElementById('thumbnail')
      photoOutput.src = ''
      $('#thumbnail').css('display', 'none')

      /**
       * get max length of the select element
       */

      let maxlen = document.getElementById('tlfeature').options.length

      /**
       * iterate through the options of the select element and change the text
       * we start from 1 to don't touch the default view or edit.. option
       */

      for (let i = 1; i < maxlen; i++) {
        document.getElementById('tlfeature').options[i].innerHTML = 'Marker ' + i
      }

      /**
       * end if ($('#tlfeature').val() !== null)
       * end $('#markdel').on('click', function (e)
       */
    }
  })

  /**
   * submit form handler
   */

  $(document).ready(function (e) {
    $('#Form').on('submit', function (e) {
      /**
       * prevent default
       */

      e.preventDefault()

      /**
       * hide the empty comment error
       * hide the popup
       */

      $('.emptyComm').css('display', 'none')
      overlay.setPosition(undefined)

      /**
       * get the select element
       * get the actual selected option
       */

      let sel = document.getElementById('tlfeature')
      let selIds = sel[sel.selectedIndex].id

      /**
       * get the textarea val
       * check if the textarea is empty
       * display the error
       * return
       */

      let getTextareaVal = $(`.${parseInt(sel.value)}`).val()

      if (getTextareaVal === '') {
        $('.emptyComm').css('display', 'block')
        return
      }

      /**
       * populate the fgeom with the marker coordinate
       * popuplate the fref with the fixed.fref
       * create a new date + 1 month
       * populate the expdate with the new date
       * popuplate the fcomment with the textarea val
       */

      $('.fgeom').val(Msource.getFeatureById(parseInt(selIds)).getGeometry().getCoordinates())
      let expDate = new Date(new Date().setDate(new Date().getDate() + 31))
      $('.expdate').val(`${expDate.getFullYear()}-${(expDate.getMonth() + 1)}-${expDate.getDate()}`)
      $('.fcomment').val(getTextareaVal)

      /**
       * disable the form buttons
       * set the opacity of the form to .1
       */

      $('#Form button').prop('disabled', true)
      $('#Form').css('opacity', '.1')

      /**
       * send an ajax request
       */
      $('.loading').show()
      $.ajax({
        type: 'POST',
        url: '/traffweb/fra-add',
        data: new FormData(this),
        beforeSend: function beforeSend(xhr) {
          xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));
        },
        contentType: false,
        cache: false,
        processData: false
      })
        .done(function (result) {
          /**
           * enable the form buttons
           * reset the opacity of the form
           */

          $('#Form button').prop('disabled', false)
          $('#Form').css('opacity', '')

          /**
           * parse the result and assign it to response
           * check which error came back
           * display the correct message
           */

          let response = result

          if (response == 1) {
            $('.plotError').text('An error occur, Please try again later.')
            $('#photopopup').modal('show')
            return
          }
          else if (response == 2) {
            $('.plotError').text('An error occur with the photo: ' + response.ERROR)
            $('#photopopup').modal('show')
            return
          }

          /**
           * if there are no errors
           * reset the form
           * display the marker button
           */

          else {
            $('#Form')[0].reset()
            $('#FraMarker').css('display', 'block')
          }

          /**
           * reset the val of fileToUpload
           * reset the source of the thumbnail preview
           * hide the thumbnail preview
           */

          $('#fileToUpload').val('')
          var photoOutput = document.getElementById('thumbnail')
          photoOutput.src = ''
          $('#thumbnail').css('display', 'none')

          /**
           * create the fault list
           */

          addMyMarkers(result)

          /**
           * update the layer parameters to dipslay the new item in the map
           */

          iDelRef = iDelRef + '1'
          fralayers.updateLayerParams($('#frapsafeatclick').val(), iDelRef)

          /**
           * remove the marker from the map and hide the tools menu
           * set counter to false
           */

          counter = false

          /**
           * add the last symbols to the main symbols array
           */

          mySource.unshift(Msource.getFeatureById(parseInt(selIds)).getProperties().mysource)

          /**
           * remove the feature connected to that ID
           */

          Msource.removeFeature(Msource.getFeatureById(parseInt(selIds)))

          /**
           * remove the textarea before to iterate through the rest of textareas
           * remove selected option and switch to the defaul option
           * reset the value of the select element
           */

          $(`.${parseInt(selIds)}`).remove()
          $(`#${parseInt(selIds)}`).remove()
          $('#tlfeature').val('')

          /**
           * hide the fault form
           * hide the marker div
           * close the fault form
           * close the tools menu
           */

          $('#fra-form-modal').modal('hide')
          if (functions.mobileTabletView()) {
            if ($('#dropdownToolsMobile em').hasClass('fa-caret-down')) {
                $('#dropdownToolsMobile').trigger('click')
            }
          }

          if ($('#dropdownTools').hasClass('fa-caret-down')) {
            $('#dropdownTools').trigger('click')
          }

          $('#msgSuccess').css('display','block')
          $('#msgSuccess').text('Thank you for reporting a fault')
          $('#msgError').css('display','none')
          $('#msgDialog').modal('show')
          $('#toolbar').show()
          $('#faultCard').show()

          /**
           * end DONE
           */
        })
        .fail(function (response) {
            let  error = response.responseJSON.error
            let  textStatus = response.status
            let err = `${textStatus}, ${error}`
            /**
               * remove the feature connected to that ID
               */

            Msource.removeFeature(Msource.getFeatureById(parseInt(selIds)))

            /**
              * remove the textarea before to iterate through the rest of textareas
              * remove selected option and switch to the defaul option
              * reset the value of the select element
              */

            $(`.${parseInt(selIds)}`).remove()
            $(`#${parseInt(selIds)}`).remove()
            $('#tlfeature').val('')

            /**
              * hide the fault form
              * hide the marker div
              * close the fault form
              * close the tools menu
              */

            $('#fra-form-modal').modal('hide')
            if (functions.mobileTabletView()) {
              if ($('#dropdownToolsMobile em').hasClass('fa-caret-down')) {
                  $('#dropdownToolsMobile').trigger('click')
              }
            }

            if ($('#dropdownTools').hasClass('fa-caret-down')) {
              $('#dropdownTools').trigger('click')
            }

            $('#msgSuccess').css('display','block')
            $('#msgSuccess').text(err)
            $('#msgError').css('display','none')
            $('#msgDialog').modal('show')
            $('#toolbar').show()
            $('#faultCard').show()
        })
        .always(() => {
          /**
           * hide the loading bar
           */

          $('.loading').hide()
        })
    }) // end form on submit

    /**
     * file type validation on fileToUpload change
     */

    $('#fileToUpload').change(function (event) {
      /**
       * get the file
       * initialize imagefile to empty
       * assign #thumbnail to output
       */

      let file = this.files[0]
      let imagefile = ''
      let output = document.getElementById('thumbnail')

      /**
       * check if the file is undefined
       * reset the uotput src
       * hide the thumbnail preview
       */

      if (file === undefined) {
        output.src = ''
        $('#thumbnail').css('display', 'none')
      }

      /**
       * check if the file is not undefined
       * assign file.type to imagefile
       * assign the correct output.src
       * style the thumbnail preview
       */

      if (file !== undefined) {
        imagefile = file.type
        output.src = URL.createObjectURL(event.target.files[0])
        $('#thumbnail').css({
          'display': 'inline',
          'width': '60px',
          'height': '60px',
          'margin': '5px',
          'margin-bottom': '10px'
        })
      }

      /**
       * validate the file type
       * list the supported file in the match array
       */

      let match = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif']

      /**
       * check if the file is not supported
       * display an error
       * display the modal with the error
       * reset the val of fileToUpload
       * hide the thumbnail preview
       */

      if (!((imagefile === match[0]) || (imagefile === match[1]) || (imagefile === match[2]) || (imagefile === match[3]))) {
        $('.plotError').text('Please select a valid image file (JPEG/JPG/PNG/GIF).')
        $('#photopopup').modal('show')
        $('#fileToUpload').val('')
        $('#thumbnail').css('display', 'none')
      }

      /**
       * end $('#fileToUpload').change(function (event)
       * end document.ready
       */
    })
  })

  /**
   * initialie myMarkers to empty
   * initialize tempMark
   */

  let myMarkers = ''
  let tempMark = sessionStorage.getItem('mymarkers')

  /**
   * create the plotted markers list
   */

  const addMyMarkers = (myref) => {
  /**
   * check if myref is not empty
   */

    if (myref !== '') {
    /**
     * check if myMarkers is populated
     * add myref to myMarkers and create a list
     * else assign myref to myMarkers
     */

      if (myMarkers.length) {
        myMarkers = `${myMarkers},${myref}`
      }
      else {
        myMarkers = myref
      }
    }

    /**
     * check if myMarkers is populated
     */

    if (myMarkers.length) {
      /**
       * empty plfeature
       * create an option with View or edit... text and value
       * append it to plfeature
       */

      $('#plfeature').empty()

      $('<option>', {
        'value': 'View or edit ...',
        'text': 'View or edit ...'
      }).appendTo('#plfeature')

      /**
       * parse myMarkers and assign it to jsonMarkers
       * set the sessionStorage mymarkers to myMarkers
       */
      let jsonMarkers = jQuery.parseJSON(`[${myMarkers}]`)
      sessionStorage.setItem('mymarkers', myMarkers)

      /**
       * iterate through jsonMarkers
       */
      jQuery.each(jsonMarkers, function () {
        /**
         * assign this to mark
         * split by space mark
         */

        let mark = this
        let stamp = mark.tstamp.split(' ')

        /**
         * assign stamp[1] to time
         * assign stamp[0] to date and plit by -
         */

        let time = stamp[1]
        let date = stamp[0].split('-')

        /**
         * modify the date format
         * create the timeStamp merging newdate and time
         */

        let newdate = date.reverse().join('/')
        let timeStamp = `${newdate} ${time}`

        /**
         * create the option item
         * append it to plfeature
         */

        let bitOfList = `<option value='mark_${mark.fid}' id='${mark.easting}_${mark.northing}'>Ref: ${mark.fref} Logged: ${timeStamp}</option>`
        $('#plfeature').append(bitOfList)
      })
    }
  }

  /**
   * check if tempMark is not null
   * assign tempMark to myMarkers
   * create the fault list
   */

  if (tempMark !== null) {
    myMarkers = tempMark
    addMyMarkers('')
  }

  /*
   * fault list location button
   */

  $('#plmarkloc').on('click', function (e) {
    /**
     * prevent default behaviour
     * hide the popup
     */

    e.preventDefault()

    overlay.setPosition(undefined)

    /**
     * prevent error enabling the click just if the value of the option selected is not empty
     */

    if (document.getElementById('plfeature').selectedIndex !== 0) {

      /**
       * get the select element
       * get the actual selected option
       * get the coordinates from the selector
       */

      let selector = document.getElementById('plfeature')
      let selectId = selector[selector.selectedIndex].id.split('_')

      let east = parseFloat(selectId[0])
      let north = parseFloat(selectId[1])

      /**
       * check if it's a mobile device
       * hide the tools menu
       */

      if (functions.mobileTabletView()) {
        $('#dropdownToolsMobile').trigger('click')
      }

      /**
       * get the resolutions array from the map
       * move the zoom level
       * move the map to the exact location of the marker
       */

      let zoom = mapView.getView().getResolutions()
      mapView.getView().setResolution(zoom[zoom.length - 1])
      mapView.getView().centerOn([east, north], mapView.getSize(), [($('#map').innerWidth() / 2), ($('#map').innerHeight() / 2)])
    }
  })

  $('#fra-form-modal-close').click(function (){
    $('#markdel').trigger('click')
  })

/**
 * end initVector
 */
}





/**
 * EXPORT
 */

export default {
  initVector
}
